<template>
  <DefaultLayout>
    <template slot="center">
      <div class="white-card" style="min-height: 300px">
        <div class="loader absolute" v-if="loading"></div>
        <template v-if="subject">
          <h3 class="text-green text-center mb-4">{{subject.name}}</h3>
          <div class="chapters__item mb-5" v-for="(chapter,i) in subject.chapters" :key="i"
               :id="'chapter'+chapter.id">
            <h5>- Chapitre {{ i + 1 }} -</h5>
            <div class="d-flex justify-content-between">
              <h5 class="title fz-28 ml-2">{{ chapter.name }}</h5>
              <div class="bg-layer text-dark user-select-none py-2 px-3 fw-200 rounded-5 d-none-sm ml-auto">
                Avancement <strong class="">{{ average(chapter.lessons) }}%</strong>
              </div>
            </div>
            <div class="line bg-gray mt-1 mb-3"></div>
            <lesson-item v-for="(lesson,i) in chapter.lessons" :key="i" :lesson="lesson"></lesson-item>
          </div>
        </template>
      </div>
    </template>
  </DefaultLayout>
</template>
<script>
import moment from 'moment';
import LeftSidebarBottom from '../components/LayoutPartials/LeftSideBarBottom'
import LeftSidebarTop from '../components/LayoutPartials/LeftSideBarTop'
import {mapGetters} from 'vuex'
import LessonItem from "@/components/Subject/LessonItem";
import _ from "lodash";
import DefaultLayout from "@/Layout/DefaultLayout";

export default {
  components: {
    DefaultLayout,
    LeftSidebarTop,
    LeftSidebarBottom,
    LessonItem
  },
  name: 'SubjectProgram',
  data() {
    return {
      subject: null,
      loading: false
    }
  },
  watch: {
    '$route.params.slug'() {
      this.load()
    }
  },
  methods: {
    average(lessons) {
      return parseInt(_.meanBy(lessons, 'progress')) || 0
    },
    load() {
      this.loading = true
      this.$store.dispatch('subject/fetchSubject', this.$slugId(this.$route.params.slug))
        .then(data => {
          this.subject = data
        })
        .finally(() => this.loading = false)
    }
  },
  created() {
    this.load()
  }
}
</script>
<style>
</style>
